import { getQueryFilters } from 'helpers/filters';
import { fetchFromObject } from 'helpers/object';
import { FILTERS_BY_DEFAULT } from 'store/enums';

export default {
  getFiltersByPage: state => (page, filter) => {
    if (filter) {
      return fetchFromObject(state[page].filters, filter);
    }
    return state[page].filters;
  },
  getPaginationByPage: state => page => fetchFromObject(state[page], 'pagination'),
  getQueryStringFilters: state => page => getQueryFilters(state[page].filters),
  getFilterHasChanged: state => page => fetchFromObject(state[page], 'filtersHasChanged'),
  getFiltersHasReseted: state => page => fetchFromObject(state[page], 'filtersHasReseted'),
  getTabActiveByPage: state => page => fetchFromObject(state[page], 'tabActive'),
  isFilterDefault: state => page =>
    JSON.stringify(fetchFromObject(state[page], 'filters')) ===
    JSON.stringify(FILTERS_BY_DEFAULT[page].filters)
};
